export default function zeroAdd(number: number | string | any) {
    return number.toString().padStart(2, '0');
}
